import { useEffect, useState } from "react"
import { Link } from "react-router-dom"

import i18next from "i18next"

import { getAirlinesMiniInfo } from "../../../info/allAirlines"

import Card from "../../../components/ui/Card"

import { useDispatch } from 'react-redux'
import { setShowSearch } from '../../../store/appConfigsSlice'
import { Cards, Title, Wrapper } from "./style"

export const AirlinesList = () => {
  const { t, language } = i18next;
  const dispatch = useDispatch()

  const [airlines, setAirlines] = useState([]);

  useEffect(() => {
    const getAirlines = async () => {
      const airlines = await getAirlinesMiniInfo(0, false);

      setAirlines(airlines);
    };

    getAirlines();
  }, []);

  useEffect(() => {
    dispatch(setShowSearch(false));
  }, [dispatch]);

  return (
    <Wrapper>
      <Title>{t("airlines")}</Title>
      <Cards>
        {airlines.map((item, index) => {
          const destination = {
            pathname: `${item.key}`,
            state: { ...item.name },

          };
          return (
            <Link key={item.key} to={destination}>
              <Card imageSrc={item.imageUrl} title={item.name[language]} />
            </Link>
          );
        })}
      </Cards>
    </Wrapper>
  );
};
